import a from "styled-components";
import { Text as p } from "./atoms-v243.js";
import { breakpoints as i } from "./atoms-v2125.js";
import { CheckoutFooter as n } from "./atoms-v289.js";
const t = a.div`
  display: flex;
  flex-direction: column;
  padding: 24px;

  @media ${i.small} {
    padding: 16px;
  }
`, g = a.div`
  border: 1px solid
    ${({ $colorTheme: o, $isSelected: r, theme: d }) => r ? d == null ? void 0 : d.get(`tokens.border.${o}.main`) : d == null ? void 0 : d.get(`tokens.border.${o}.light`)};
  border-radius: ${({ $isFirst: o, $isLast: r, theme: d }) => {
  const s = (d == null ? void 0 : d.get("tokens.radius.cardRadiusMed")) ?? 0;
  return `
      ${o ? s : 0}px 
      ${o ? s : 0}px 
      ${r ? s : 0}px 
      ${r ? s : 0}px
    `;
}};
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 20px 26px;
  width: 100%;

  @media ${i.small} {
    padding: 14px 16px;
  }
`, u = a.div`
  display: flex;
  justify-content: space-between;

  @media ${i.small} {
    flex-direction: column;
    gap: 2px;
  }
`, k = a(p)`
  color: ${({ $colorTheme: o, theme: r }) => r == null ? void 0 : r.get(`tokens.text.${o}.secondary`)};
  ${({ theme: o }) => o == null ? void 0 : o.get("tokens.body.compact-expressive").toJS()};

  @media ${i.small} {
    ${({ theme: o }) => o == null ? void 0 : o.get("tokens.body.compact-productive").toJS()};
  }
`, b = a.div`
  display: flex;
  gap: 4px;
`, y = a(p)`
  color: ${({ $colorTheme: o, theme: r }) => r == null ? void 0 : r.get(`tokens.text.${o}.primary`)};
  ${({ theme: o }) => o == null ? void 0 : o.get("tokens.body.compact-expressive").toJS()};

  @media ${i.small} {
    ${({ theme: o }) => o == null ? void 0 : o.get("tokens.body.productive").toJS()};
  }
`, f = a(p)`
  color: ${({ $colorTheme: o, theme: r }) => r == null ? void 0 : r.get(`tokens.text.${o}.primary`)};
  ${({ theme: o }) => o == null ? void 0 : o.get("tokens.body.productive").toJS()};

  @media ${i.small} {
    ${({ theme: o }) => o == null ? void 0 : o.get("tokens.helper.productive").toJS()};
  }
`, v = a(p)`
  color: ${({ $colorTheme: o, theme: r }) => r == null ? void 0 : r.get(`tokens.text.${o}.tertiary`)};
  ${({ theme: o }) => o == null ? void 0 : o.get("tokens.body.compact-productive").toJS()};
`, R = a(n)`
  @media ${i.large} {
    border-radius: 0 0 ${({ theme: o }) => {
  var r;
  return (r = o == null ? void 0 : o.get) == null ? void 0 : r.call(o, "tokens.radius.modalRadius");
}}px
      ${({ theme: o }) => {
  var r;
  return (r = o == null ? void 0 : o.get) == null ? void 0 : r.call(o, "tokens.radius.modalRadius");
}}px;
  }
`;
export {
  R as CheckoutFooterWithBorderRadius,
  g as RateCard,
  v as RateCardDescription,
  u as RateCardHeader,
  y as RateCardPrice,
  b as RateCardPriceSection,
  f as RateCardPriceText,
  k as RateCardTitle,
  t as Wrapper
};
